import Platform from"react-native-web/dist/exports/Platform";export const springDefaults={stiffness:150,damping:21,mass:1,useNativeDriver:false};